import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        getUnidades(params) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(params)}`)
        },
        getCotaPrestador(params) {
            return repository.get(`${baseUrl}/cota?${urlUtil.serialize(params)}`)
        },
    }
}